export const TruckRouteTypeEnum = {
  Delivery: 1,
  Pickup: 2,
};
export const AssignTypeEnum = {
  Sites: 1,
  Distributor: 2,
};
export const ManageTruckRouteTypeEnum = {
  Delivery: 'D',
  Pickup: 'P',
};

export const TabEnum = {
  TruckRoute : 'TruckRoute',
  TruckRouteSchedule : 'TruckRouteSchedule'
};


// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/TruckRouteEnum.js